import { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

import { InputTextVertical, VerticalInputFormLayout } from "@components";

import useCustomSelector from "@redux/hooks/useCustomSelector";
import useActionCreator from "../../../../../../redux/hooks/useActionCreator";

import { OfficeCreateType } from "@type/inventory/office";

export default function OfficeForm() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<OfficeCreateType>();

  const { officeCreateActionHandler } = useActionCreator();

  const onSubmit: SubmitHandler<OfficeCreateType> = (data) => {
    officeCreateActionHandler(data);
  };

  const { createSuccess } = useCustomSelector(
    (store) => store.inventory.roomConfigOfficeState,
  );

  useEffect(() => {
    if (createSuccess) {
      reset();
    }
  }, [createSuccess]);

  return (
    <VerticalInputFormLayout
      label="INVENTORY_ROOM_CONFIG.OFFICE.FORM.HEADER"
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
    >
      <InputTextVertical
        label="INVENTORY_ROOM_CONFIG.OFFICE.FORM.FIELDS.NAME"
        register={{
          ...register("name", { required: "Name is Required" }),
        }}
        error={errors}
        required
        cols={3}
      />
      <InputTextVertical
        label="INVENTORY_ROOM_CONFIG.OFFICE.FORM.FIELDS.ADDRESS"
        register={{
          ...register("address", { required: "Address is Required" }),
        }}
        error={errors}
        required
        cols={3}
      />
    </VerticalInputFormLayout>
  );
}
